module.exports = {"meta":{"lead":"Comprendre l'IA pour la démystifier"},"menu":{"home":"Accueil"},"translationss":"Configuration des traductions"};